<template>
  <v-menu left
          v-if="personPhones &&
                Array.isArray(personPhones) &&
                personPhones.length">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn class="mr-2"
                 large
                 :loading="connectingCall"
                 color="kbDarkBlueText"
                 icon
                 v-on="{ ...tooltip, ...menu }">
            <v-icon size="30px">feather-phone-call</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('general.call') }}</span>
      </v-tooltip>
    </template>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-list color="kbLight">
          <template v-for="(phoneObj, index) in personPhones">
            <v-list-item :key="`phone-${index}`"
                         style="position: relative"
                         @click="callPerson(selectedUser.userId, phoneObj)">
              <v-list-item-content>
                <v-list-item-title class="kbDarkBlueText--text d-flex align-center">
                  <img style="margin-top: 5px"
                       class="iti-flag mr-3 mt-0"
                       :class="phoneObj.countryCode">
                  <span class="kbDarkBlueText--text text-capitalize">
                    +{{ phoneObj.number }}
                  </span>
                  <span class="kbDarkBlueText--text text-capitalize pl-2">
                    {{ phoneObj.phone }}
                  </span>
                </v-list-item-title>

                <v-list-item-subtitle class="text-capitalize mt-1">
                  {{ phoneObj.name }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-icon color="kbGold"
                      style="position: absolute; right: 15px; top: 15px"
                      v-if="phoneObj.main">
                mdi-star
              </v-icon>
            </v-list-item>
            <v-divider :key="`divider-${index}`" v-if="index < personPhones.length - 1" />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapGetters(['userExtraDatas']),
    ...mapState({
      selectedUser: state => state.users.selectedUser
    }),
    personPhones () {
      let extraDataPhones = []
      if (this.userExtraDatas &&
        Array.isArray(this.userExtraDatas) &&
        this.userExtraDatas.length) {
        extraDataPhones = this.userExtraDatas
          .filter(item => item.type === 'phone' && item.value)
          .map(item => {
            const phoneObj = JSON.parse(item.value)
            return {
              name: item.field,
              phone: phoneObj.phone,
              number: phoneObj.number,
              countryCode: phoneObj.code,
              main: false
            }
          })
      }
      if (this.selectedUser.phone) {
        const userPhone = {
          name: this.$t('general.mainPhone'),
          phone: this.selectedUser.phone,
          number: this.selectedUser.countryCode,
          countryCode: this.selectedUser.country,
          main: true
        }
        extraDataPhones.unshift(userPhone)
      }
      return extraDataPhones
    }
  },
  data () {
    return {
      connectingCall: false
    }
  },
  methods: {
    async callPerson (userId, phoneObj) {
      try {
        this.connectingCall = true
        const data = {
          recordId: userId,
          to: `+${phoneObj.number}${phoneObj.phone}`
        }
        await this.$store.dispatch('callPerson', {
          companyId: this.$store.getters.companyUuid,
          appId: this.$store.getters.appUuid,
          data
        })
        this.connectingCall = false
      } catch (e) {
        this.connectingCall = false
        notifications.error(e)
      }
    }
  }
}
</script>
